export const PAGE_NAME = 'gig_page';
export const BQ_CLICKED_REVIEWS_RATINGS = 'clicked_on_ratings_stars_gig_page';
export const REVIEWS_SECTION_KEY = 'reviews';
